import { useEffect, useState } from 'react';
import useReduxData from '../../../Hooks/useReduxData';
import { toast } from 'react-toastify';
import { RoleTitle } from '../../../Context/constants';
import moment from 'moment-timezone';
import { CLINIC_LIST } from '../../Repository/ProfileRepo';
import { GET_TEAM_REPORT } from '../../Repository/InsightsRepo';

const useTeamReport = () => {
    const { reduxData: userdata } = useReduxData("userDataRDX")
    const [dateRangeDropdown, setDateRangeDropdown] = useState(false)
    // const [controller, setController] = useState({ page: 1, rowsPerPage: 7 });
    const [dateFilter, setDateFilter] = useState('TODAY')
    // const [selectClinic, setSelectClinic] = useState([{ clinicName: "All", clinicId: "ALL_CLINCI" }])
    const [selectClinic, setSelectClinic] = useState([{ clinicName: userdata?.location?.clinicName, clinicId: userdata?.location?.clinicId }])
    const [clinicList, setClinicList] = useState([])
    const [Reports, setReports] = useState({})
    const [loader, setloader] = useState(false)
    const [action, setAction] = useState(false)
    const [sorting, SetSorting] = useState("TOTAL_BOOKING")
    const [filterPopup, setFilterPopup] = useState(false)
    const [customDate, setCustomDate] = useState({
        startDate: "",
        endDate: ""
    })
    const [appointmentFilter, setAppointmentFilter] = useState([
        { label: "Booked", value: "BOOKED" },
        { label: "Cancelled", value: "CANCELLED" },
        { label: "CheckedOut", value: "CHECKOUT" },
    ])
    const headCells = [
        { id: "Rank", numeric: false, disablePadding: true, label: "Rank" },
        { id: "Images", numeric: false, disablePadding: true, label: "Image" },
        { id: "Staff", numeric: true, disablePadding: false, label: "Team" },
        { id: "Total Booking", numeric: true, disablePadding: false, label: "Total Booking" },
        { id: "Total Revenue", numeric: true, disablePadding: false, label: "Total Revenue" },
    ];

    // get list clinic 
    const getClinicList = async () => {
        let payload = {
            activeStatus: true,
            staffId: (userdata.roleTitle === RoleTitle.STAFF || userdata.roleTitle === RoleTitle.FRONT_DESK) ? userdata?.userId : undefined,
            providerId: (userdata.roleTitle === RoleTitle.STAFF || userdata.roleTitle === RoleTitle.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
            roleTitle: userdata?.roleTitle
        }
        setloader(true)
        try {
            let response = await CLINIC_LIST(payload)
            setClinicList(response.data)
            setloader(false)
        } catch (error) {
            setloader(false)
            setClinicList([])
        }
    }

    const getTeamDetail = async () => {
        let payload = {
            providerId: userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.providerId : userdata.userId,
            clinicId: selectClinic[0]?.clinicId === "ALL_CLINCI" ? null : selectClinic[0]?.clinicId,
        }
        if (dateFilter === 'TODAY') {
            payload.startDate = moment().startOf('day')
            payload.endDate = moment().endOf('day')
        }
        if (dateFilter === 'LAST7') {
            payload.startDate = moment().startOf('day').subtract(7, 'days')
            payload.endDate = moment().endOf('day')
        }
        if (dateFilter === 'LAST30') {
            payload.startDate = moment().startOf('day').subtract(30, 'days')
            payload.endDate = moment().endOf('day')
        }

        if (dateFilter === 'CUSTOM' && customDate?.startDate === '' && customDate?.endDate === '') return toast.warn('Please select start date and end date ')
        if (dateFilter === 'CUSTOM' && customDate?.startDate === '') return toast.warn('Please select start date')
        if (dateFilter === 'CUSTOM' && customDate?.endDate === '') return toast.warn('Please select end date')
        if (customDate?.startDate > customDate?.endDate) return toast.warn('Start date can not be greater than end date ')
        else if (dateFilter === 'CUSTOM') {
            payload.startDate = moment(customDate?.startDate).startOf('day')
            payload.endDate = moment(customDate?.endDate).endOf('day')
        }
        setloader(true)
        setFilterPopup(false)

        try {
            let response = await GET_TEAM_REPORT(payload)
            setloader(false)
            setReports(response?.data)
        } catch (error) {
            toast.error(error?.message)
            setReports({})
            setloader(false)
        }
    }
    useEffect(() => {
        getTeamDetail()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [action])
    useEffect(() => {
        getClinicList()
        window.addEventListener("click", () => {
            setDateRangeDropdown(false)
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return {
        loader,
        selectClinic,
        clinicList,
        Reports,
        headCells,
        dateRangeDropdown,
        dateFilter,
        setDateRangeDropdown,
        setSelectClinic,
        setDateFilter,
        filterPopup,
        setFilterPopup,
        SetSorting,
        sorting,
        userdata,
        customDate, setCustomDate,
        setAction,
        getTeamDetail,
        setAppointmentFilter,
        appointmentFilter,
    }
}

export default useTeamReport
